<template>

<v-main class="mt-12">
    <v-card
        width=1300
        flat
        dark
        class="mx-auto blueGrey">

        <v-tabs
            v-model="tabs"
            center-active
            background-color="blueMain"
            color="orangeMain"
            grow>
            <v-tab
                v-for="name in Object.keys(ratingnames)"
                :key="name"
                @click="getrating(name)"
                >

                {{ name }}
            </v-tab>
        </v-tabs>

        <v-tabs-items
            v-model="tabs"
            class="blueMain"
            dark
            >
            <v-tab-item
                v-for="name in Object.keys(ratingnames)"
                :key="name">
                <v-container grid-list-md>
                    <v-layout row>
                        <v-flex xs12>
                            <div v-if="Object.keys(userinfo).length > 0 &&
                                       Object.keys(shopinfo).length > 0 &&
                                       rating[ratingnames[name]]">
                                <div
                                    v-for="(period, key) in rating[ratingnames[name]]"
                                    :key="name + key">

                                    <span>{{ key }}</span>
                                    <v-simple-table
                                        class="blueDark">
                                        <template>
                                            <thead>
                                                <tr>
                                                    <th class="text-left blueGrey">Место</th>
                                                    <th class="text-left blueGrey">Продавец</th>
                                                    <th class="text-left blueGrey">Домашний магазин</th>
                                                    <th class="text-right blueGrey">Результат</th>
                                                </tr>
                                            </thead>

                                            <tbody class="text-left">
                                                <tr
                                                    v-for="(item, index) in period.filter(el=>userinfo[el.id])"
                                                    :key="index">

                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ userinfo[item.id].name }} 
                                                        <v-rating
                                                            readonly
                                                            background-color="blueGrey"
                                                            color="orangeMain"
                                                            dense
                                                            :value='userinfo[item.id].status ? status[userinfo[item.id].status] : 0'
                                                            length='4'
                                                            size="12" >
                                                        </v-rating>
                                                    </td>
                                                    <td>
                                                        {{ `${shopinfo[userinfo[item.id].shop].ID} ${shopinfo[userinfo[item.id].shop].shopname}` }}
                                                    </td>
                                                    <td class="text-right">
                                                        {{ item.result | money }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <br>
                                </div>
                            </div>
                            <div v-else>
                                <v-img
                                    :src="rating_img"> </v-img>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</v-main>

</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios'

export default {
name: 'Rating',
components: {
},
data: () => ({
    status: {'стажер': 1, 'юниор': 2, 'мастер': 3, 'эксперт': 4},
    userinfo: {},
    tabs: null,
    rating_img: 'https://251317.selcdn.ru/oboi.ru/sup/orange.loader.gif',
    rating: {},
    year: new Date().getFullYear(),
    month: new Date().getMonth(),
    ratingnames: {
      'Продажи': 'sales',
      'Эффективность': 'efficiency',
      'Лучший дебют': 'bestJunior',
      'Средний чек': 'averCheck',
      'Наибольший чек': 'check',
      'Трудолюбие': 'workingDays',
      'Stenova Home': 'stenovahome'
  },
    ratingperoid: {
      'Продажи': [{'name': 'за 6 месяцев включая текущий', 'month': 5}],
      'Эффективность': [{'name': 'за 3 месяца включая текущий'}],
      'Лучший дебют': [{'name': 'за все время работы'}],
      'Средний чек': [{'name': 'за 6 месяцев включая текущий', 'month': 5},
                      {'name': 'за текущий месяц'}],
      'Наибольший чек': [{'name': 'за 6 месяцев включая текущий', 'month': 5},
                         {'name': 'за текущий месяц'}],
      'Трудолюбие': [{'name': 'за 6 месяцев включая текущий', 'month': 5},
                     {'name': 'за текущий месяц'}],
      'Stenova Home': [{'name': 'за 6 месяцев включая текущий', 'month': 5},
                       {'name': 'за текущий месяц'}]
  },
}),

computed: {

    ...mapState(['domen', 'shopinfo']),
},

methods: {
  async datauser () {
      return axios.post(this.domen + '/service/userinfo', {
          'year': this.year,
          'month': this.month + 1
      }).then(res => res.data)
        .then(json => {
          let userinfo = {}
          for (let el of json['response'])
              userinfo[el.id] = el;
          this.userinfo = {...this.userinfo, ...userinfo};
      })
        .catch(err => window.console.warn(err))
  },

    async getrating (ratingname) {
      let rating = this.ratingnames[ratingname]
      if (this.rating[rating]) return {};
      let data = this.ratingperoid[ratingname];
      for (let element of data){
        let date = new Date(this.year, this.month - (element.month || 0), 1);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let name = element.name;
        axios.post(this.domen + '/service/rating', {
          'year': year,
          'month': month,
          'rating': rating,
        }).then(res => res.data)
          .then(json => {
          rating = {};
          for (let key in json['response']){
            rating[key] = this.rating[key] ? this.rating[key] : {};
            rating[key][name] = json['response'][key];
          }
          this.rating = {...this.rating, ...rating};
        });
      }
    }

},

watch: {

},

created: function(){
  for (let el of Object.keys(this.ratingnames))
    this.getrating(el);
  this.datauser();
},



}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
